<usimweb-status-bar
  *ngIf="progress"
  style="top: 0px !important; height: 20px"
  [mode]="'indeterminate'"
></usimweb-status-bar>

<div class="space">
  <usimweb-button-icon [icon]="'arrow_back'" fontColor="white" (btnClick)="back()"></usimweb-button-icon>
</div>

<usimweb-project-stepper (clickEvent)="create($any($event))"></usimweb-project-stepper>
